import { configureStore } from '@reduxjs/toolkit';
import reducers from './Reducers';
import { persistReducer, persistStore } from 'redux-persist';
import createFilter from 'redux-persist-transform-filter';
import storage from 'redux-persist/lib/storage';
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE } from 'redux-persist/es/constants';

const saveSharedFilters = createFilter(
  'sharedReducer',
  [
    'selectedCompany',
    'includeSuborgs',
    'selectedLocation',
    'selectedCountry',
    'selectedUserAccess',
    'tableColumnVisibility',
    'customerDashboardInService',
    'customerDashboardFullService',
  ],
  [
    'selectedCompany',
    'includeSuborgs',
    'selectedLocation',
    'selectedCountry',
    'selectedUserAccess',
    'tableColumnVisibility',
    'customerDashboardInService',
    'customerDashboardFullService',
  ]
);

const persistConfig = {
  key: 'shared',
  storage,
  whitelist: ['sharedReducer'],
  transforms: [saveSharedFilters],
  stateReconciler: (persistedState, storeState) => {
    let newState = { ...storeState };

    if (persistedState?.sharedReducer) {
      newState = {
        ...newState,
        sharedReducer: {
          ...storeState.sharedReducer,
          ...persistedState.sharedReducer,
        },
      };
    }

    return newState;
  },
};

/*
 * TODO: we can enable type checking for the reducer (and all useSelector calls) by passing the following generics:
 *       const pReducer = persistReducer<RootReducerState, AnyAction>(persistConfig, reducers);
 *       However, the correct typing causes tons of (valid) TypeScript errors, which would have to be fixed first.
 *       The main cause is that most fields in /src/features/shared/shared.slice.ts are typed as `unknown`,
 *       we should start with fixing those first, and then maybe revisit this line.
 */
const pReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: pReducer,
  devTools: true,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
      thunk: {
        extraArgument: '',
      },
    }),
});
export const persistor = persistStore(store);

export type DispatchAction<T> = {
  type: string;
  payload: T;
};

/**
 * @deprecated use `RootReducerState` from `src/redux/Reducers.ts` instead
 */
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
